import React, { useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Card,
    CardContent,
    Box,
    InputAdornment,
} from '@mui/material';
import { Email, Lock } from '@mui/icons-material';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { collection, addDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { auth, db } from '../../firebase';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async () => {
        if (!email || !password) {
            toast.error('Please enter email and password');
            return;
        }

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // 3. Fetch user role
            const q = query(collection(db, 'users'), where('uid', '==', user.uid));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const userData = querySnapshot.docs[0].data();

                if (userData.role === 'Manager') {
                    toast.success('Login successful');
                    window.location.href = "/home";
                } else {
                    toast.error('Access denied.');
                    await signOut(auth);
                }
            } else {
                toast.error('User role not found.');
                await signOut(auth);
            }

            await addDoc(collection(db, 'loginhistory'), {
                uid: user.uid,
                email: user.email,
                loginTime: serverTimestamp(),
            });

            toast.success('Login successful');
            window.location.href = "/home"
        } catch (error) {
            console.error(error);
            if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
                toast.error('Invalid email or password');
            } else {
                toast.error(error.message);
            }
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(to right, #9d850aff, #eb630fff)',
            }}
        >
            <Card
                sx={{
                    maxWidth: 400,
                    width: '100%',
                    boxShadow: 8,
                    borderRadius: 4,
                    backgroundColor: 'white',
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="center" mb={3}>
                        <img src="/logo.png" alt="Logo" style={{ height: '150px' }} />
                    </Box>

                    <Typography
                        variant="h5"
                        align="center"
                        gutterBottom
                        sx={{
                            fontWeight: 'bold',
                            background: 'linear-gradient(90deg, #eb630fff, #9c27b0)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                        }}
                    >
                        शिवअंबा पूजा साहित्य व प्रासादिक भांडार
                    </Typography>

                    <TextField
                        label="Email Address"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Email />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="Password"
                        variant="outlined"
                        type="password"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Button
                        fullWidth
                        sx={{
                            mt: 3,
                            py: 1.5,
                            background: 'linear-gradient(to right, #eb630fff, #9c27b0)',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            borderRadius: 2,
                            '&:hover': {
                                background: 'linear-gradient(to right, #5c6bc0, #ab47bc)',
                            },
                        }}
                        onClick={handleLogin}
                    >
                        Sign In
                    </Button>

                    {/* <Typography
                        variant="body2"
                        align="center"
                        sx={{ mt: 3, color: '#555' }}
                    >
                        Don't have an account?{' '}
                        <a href="/register" style={{ color: '#eb630fff', fontWeight: 'bold' }}>
                            Register
                        </a>
                    </Typography> */}
                </CardContent>
            </Card>
        </div>
    );
};

export default Login;
